import indexMixin from "../mixins/index";
export default {
  name: 'res-date-range-picker',
  mixins: [indexMixin],
  props: {
    type: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    rangeSeparator: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    return {
      dataModel: this.value
    };
  },

  computed: {
    printReadStr() {
      return this.dataModel.join(this.rangeSeparator);
    }

  },
  watch: {
    value: {
      handler(val) {
        this.dataModel = val;
      },

      immediate: true,
      deep: true
    },

    dataModel(val) {
      this.$emit("input", val);
    }

  },

  mounted() {
    let result = this.getTime();
    let {
      y,
      m,
      d
    } = result;

    if (this.type === 'timerange' && !this.dataModel.length) {
      this.dataModel = [new Date(y, m, d, 9, 0), new Date(y, m, d, 18, 0)];
    }
  },

  methods: {
    getTime(date = new Date()) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return {
        y,
        m,
        d
      };
    }

  }
};